import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  inject,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../services/theme';
import { Subscription } from 'rxjs';
import { MediaQueryService } from '../services/matchMedia';
import { PriceScalePipe } from '../pipes/price-scale.pipe';
import { PercentageChangePipe } from '../pipes/percentage-change-pipe';
import { InfoModal } from '../info-modal/info-modal';
import { makeEvent } from '../analytics/builder';
import { SnowplowService } from '../services/snowplow';

import { SmartTitleCasePipe } from '../pipes/smart-title-case.pipe';
import { ArrowButton } from '../arrow-button/arrow-button';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.html',
  styleUrl: './nav-bar.scss',
  standalone: true,
  imports: [
    CommonModule,
    InfoModal,
    ArrowButton,
    PriceScalePipe,
    PercentageChangePipe,
    SmartTitleCasePipe,
  ],
})
export class NavBar implements OnInit, OnDestroy {
  @Input() name = '';
  @Input() analyseType!: string;
  @Input() isin!: string | null;
  @Input() showCompanyLink = true;
  @Input() price!: number | null;
  @Input() prevPrice!: number | null;
  @Output() companyClick = new EventEmitter<void>();

  private readonly themeService = inject(ThemeService);
  private readonly mediaQuery = inject(MediaQueryService);
  private readonly snowplow = inject(SnowplowService);

  public isFinnet = this.themeService.isFinnet;

  get iconPath() {
    return this.themeService.isLight() ? '/info-light.svg' : '/info.svg';
  }

  get companyPath() {
    return this.themeService.isLight() ? '/companyInfo-light.png' : '/companyInfo.png';
  }

  // HELPERS
  onCompanyClick() {
    this.companyClick.emit();
  }

  // Adapt title on screen width
  isMobile = false;
  private sub?: Subscription;

  ngOnInit() {
    this.mediaQuery.watchQuery('(max-width: 768px)');
    this.sub = this.mediaQuery.matches$.subscribe((matches) => (this.isMobile = matches));
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  // Modal
  @ViewChild('modal') modal!: InfoModal;

  onInfoClick() {
    this.modal.open();

    this.snowplow.track(
      makeEvent('element_clicked', {
        element_title: 'info_icon_asset_analysis',
        feature_name: 'icon',
      }),
    );
  }

  onInfoClose() {
    this.modal.close();
  }
}
